module.exports = __webpack_public_path__ + "static/ai-1-sq-fb26015504c35561008055e59fbe8051.png";